<template>
    <v-container fluid grid-list-md>
        <v-layout>
            <v-flex>
                <h1 class="display-3">ABC Proveedores</h1>
                <div class="caption">
                    Muestra las compras a proveedores por empresa en monto ordenándolos individualmente según el importe.
                    Permite elegir cantidad o porcentaje respecto al monto total de proveedores a discriminar individualmente y
                    agrupa el resto en “otros”. Permite elegir periodo a mostrar y moneda. Los valores no incluyen impuestos.
                </div>
            </v-flex>
        </v-layout>
        <v-menu v-model="lateral" :close-on-content-click="false">
            <v-btn slot="activator" flat icon>
                <v-icon>menu</v-icon>
            </v-btn>
            <form>
                <v-card>
                    <v-card-text class="text-xs-center">
                        <empresa-select v-model="d.empresa"></empresa-select>
                        <moneda-select v-model="d.moneda"></moneda-select>
                        <v-switch label="Quitar intercompany" v-model="d.intercompany"></v-switch>
                        <v-menu
                                lazy
                                full-width
                                :close-on-content-click="false"
                                v-model="menuDesde"
                                :return-value.sync="menuDesde"
                                ref="menuDesde"
                                transition="v-scale-transition"
                        >
                            <v-text-field
                                    name="desde"
                                    slot="activator"
                                    label="Desde"
                                    v-model="d.desde"
                                    prepend-icon="event"
                                    readonly></v-text-field>
                            <v-date-picker
                                    v-model="d.desde"
                                    first-day-of-week="1"
                                    locale="es-sp"
                                    scrollable
                                    @input="$refs.menuDesde.save(date)"
                            ></v-date-picker>
                        </v-menu>
                        <v-menu
                                lazy
                                full-width
                                :close-on-content-click="false"
                                v-model="menuHasta"
                                :return-value.sync="menuHasta"
                                ref="menuHasta"
                                transition="v-scale-transition"
                        >
                            <v-text-field
                                    name="hasta"
                                    slot="activator"
                                    label="Hasta"
                                    v-model="d.hasta"
                                    prepend-icon="event"
                                    readonly></v-text-field>
                            <v-date-picker
                                    v-model="d.hasta"
                                    first-day-of-week="1"
                                    locale="es-sp"
                                    scrollable
                                    @input="$refs.menuHasta.save(date)"
                            ></v-date-picker>
                        </v-menu>
                        <v-text-field name="limit" label="Mostrar" v-model="d.limit"></v-text-field>
                        <micro-proveedor-select
                                label="Exluir proveedores"
                                v-model="d.proveedExcluir"
                                multiple
                                :empresa="d.empresa"
                                :preset="proveedExcluir"
                        ></micro-proveedor-select>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn dark default @click.native="guardaConfig()">GUARDA CONFIG</v-btn>
                        <v-btn dark default @click.native="mostrar()" :loading="loading">MOSTRAR</v-btn>
                    </v-card-actions>
                </v-card>
            </form>
        </v-menu>
        <v-layout row wrap>
            <v-flex>
                <v-progress-linear :indeterminate="true" :query="true" :active="loading" height="5"></v-progress-linear>
                <highcharts style="width: 100%" :options="chartOptions"></highcharts>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import empresaSelect from '../../components/EmpresaSelect.vue'
    import monedaSelect from '../../components/MonedaSelect.vue'
    import microProveedorSelect from '../../components/MicroProveedorSelect'
    import moment from 'moment'
    import {mapActions} from 'vuex'

    function getInitialData() {

        return {
            empresa: '',
            moneda: 2,
            desde: moment().subtract(1, 'year').format('YYYY-MM-DD'),
            hasta: moment().format('YYYY-MM-DD'),
            limit: 10,
            intercompany: false,
            proveedExcluir: []
        }
    }

    export default {
        components: {empresaSelect, monedaSelect, microProveedorSelect},
        data() {
            return {
                lateral: false,
                loading: false,
                menuDesde: false,
                menuHasta: false,
                d: getInitialData(),
                proveedExcluir: [],
                chartOptions: {
                    chart: {
                        type: 'pie',
                        backgroundColor: ''
                    },
                    title: {
                        text: 'ABC PROVEEDORES'
                    },
                    legend: {
                        enabled: true,
                    },
                    xAxis: {
                        type: 'category'
                    },
                    yAxis: {
                        title: {
                            text: 'Montos'
                        }
                    },
                    tooltip: {
                        pointFormat: '{point.name}: Monto: <b>{point.y:,.2f} ({point.percentage:,.1f} %)</b>'
                    },
                    plotOptions: {
                        series: {
                            stacking: 'normal',
                            dataLabels: {
                                enabled: true,
                                format: '{point.name}: {point.y:,.2f} ({point.percentage:,.1f} %)',
                            },
                            tooltip: {
                                pointFormat: '{point.name}: Monto: <b>{point.y:,.2f} ({point.percentage:,.1f} %)</b>'
                            },
                        }
                    },
                    series: []
                }
            }
        },
        mounted() {
            if (this.$ls.get('config.indicador.abc-proveedores')) {
                this.d = this.$ls.get('config.indicador.abc-proveedores')
                this.proveedExcluir = this.d.proveedExcluir;
            }
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            guardaConfig() {
                this.$ls.set('config.indicador.abc-proveedores', this.d)
            },
            mostrar() {
                if (!this.d.empresa) {
                    this.msjShow({tipo: 2, txt: 'Debe seleccionar empresa'});
                    return false;
                }
                this.loading = true;
                this.$http.post('indicadores/abc-proveedor', this.d)
                    .then(r => {
                        this.chartOptions.series = r.data.grafico;
                        this.loading = false;
                        this.lateral = false;
                    }, r => {
                        console.error(r)
                    });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/indicadores/abc-proveedores.vue